import * as React from 'react'
import ReactDOMServer from 'react-dom/server'

export class Message {
  constructor(
    public message: string,
    public detail: string,
    public channel: 'Info' | 'Warn' | 'Error',
    public timestamp = new Date(),
    public dismissed = false
  ) {}
}

function wrapContent(content: JSX.Element | string, type: string): string {
  if (typeof content == typeof '') {
    return ReactDOMServer.renderToString(React.createElement(type, null, content as string))
  } else {
    return ReactDOMServer.renderToString(content as JSX.Element)
  }
}

const wrapMessage = (content: JSX.Element | string): string => wrapContent(content, 'span')

const wrapDetails = (content: JSX.Element | string): string => wrapContent(content, 'p')

export function InfoMessage(
  message: JSX.Element | string,
  detail: JSX.Element | string,
  timestamp = new Date()
): Message {
  return new Message(wrapMessage(message), wrapDetails(detail), 'Info', timestamp)
}

export function WarnMessage(message: JSX.Element | string, detail: JSX.Element | string): Message {
  return new Message(wrapMessage(message), wrapDetails(detail), 'Warn')
}

export function ErrorMessage(message: JSX.Element | string, detail: JSX.Element | string): Message {
  return new Message(
    wrapMessage(message),
    wrapDetails(detail) +
      ReactDOMServer.renderToString(
        <p>Please check your network connection and try again in a minute or two.</p>
      ) +
      ReactDOMServer.renderToString(
        <p>
          If this error continues please contact{' '}
          <a href="mailto:SMARTSupport@res-group.com">SMARTSupport</a>.
        </p>
      ),
    'Error'
  )
}

export function areEqual(m1: Message, m2: Message) {
  return (
    m1.timestamp.getTime() === m2.timestamp.getTime() &&
    m1.detail === m2.detail &&
    m1.message === m2.message &&
    m1.channel === m2.channel
  )
}
